import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeService } from 'src/app/shared/services/home.service';
import { ReportService } from '../service/report.service';
import { ToplineService } from '../service/topline.service';
import { ExcelViewerService } from '../service/excel-viewer.service';

@Component({
  selector: 'app-creat-topline',
  templateUrl: './creat-topline.component.html',
  styleUrls: ['./creat-topline.component.scss']
})
export class CreatToplineComponent implements OnInit {
  public uuid:string='';
  public isAlias:boolean=false
  constructor(
    public reportService:ReportService,
    public toplineService:ToplineService,
    public router:Router,
    public homeService: HomeService,
    public evService:ExcelViewerService,
    private activaterRoute:ActivatedRoute
  ) { 
    if (this.router.url.includes('alias')) {
      this.isAlias = true
    }
    this.uuid = this.activaterRoute.snapshot.params['uuid'];
    if (!this.isAlias || !this.toplineService.fileDetails['file_uuid']) {
      this.reportService.getRepositoryDetailByFile(this.uuid,{createTopline:true})
    }
  }

  ngOnInit(): void {
  }



  breadcrumbClick(index){
    switch(index){
      case 1 : if(this.reportService.isQual){
        this.router.navigate(['qual/report/',this.reportService.studyId]);
        // this.router.navigate(['home/qual/report/',this.reportService.studyId]);
      }
      else{
        this.router.navigate(['repo/details/',this.reportService.studyId]);
        // this.router.navigate(['home/repository-report/details/',this.reportService.studyId]);
      }
      break;

      case 2 : if(this.reportService.isQual){
        this.router.navigate(['qual/interview/',this.reportService.studyId]);
        // this.router.navigate(['home/qual/interview/',this.reportService.studyId]);
      }
      else{
        this.router.navigate(['repo']);
        // this.router.navigate(['home/repository-report']);
      }
      break;
    }
  }


  

}
